export class PrivateAuctionAuthorizationRequest{
    public userId!:string;
    public bidderId!:string;
    public propertyId!:number;
    public auctionId!:number;
}